import styled from '@emotion/styled';
import { MOBILE_SUBHEADER_HEIGHT } from 'components/navigation/header.constants';

export const DESKTOP_NAVIGATION_HEIGHT = 52;

export const Root = styled.div<{ hasBorderBottom: boolean; }>`
  ${({ theme }) => `
    background: ${theme.colors.neutrals.white};

    > div {
      border: none;
      height: 100%;
    }
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    position: sticky;
    z-index: 2;
    top: ${MOBILE_SUBHEADER_HEIGHT + 1}px;
    height: 48px;
    > div > div {
      border: none;
    }
  `}

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    position: relative;
    top: 0;
    z-index: -1;
    height: ${DESKTOP_NAVIGATION_HEIGHT}px;
  `}

  ${({ theme, hasBorderBottom }) => theme.media.showAt({ from: 3 })`
    ${hasBorderBottom ? `
      border-bottom: solid 1px ${theme.colors.neutrals.grey8};
    ` : ''}
  `}
`;

export const Wrapper = styled.div`
  height: 100%;
  display: flex;
`;

export const NavigationWrapper = styled.div`
  display: flex;
  flex-grow: 1;

  .sub-menu-item > div {
    letter-spacing: 0.5px;
  }

  ${({ theme }) => theme.media.showAt({ from: 3 })`
    margin-right: -${theme.spacing(3)};

    .sub-menu-item:first-of-type {
      margin: 0;
    }
  `}
`;

export const FiltersWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    margin-left: ${theme.spacing(3)};
  `}
`;

export const NavSeparator = styled.div`
  ${({ theme }) => `
    height: 26px;
    border-right: 1px solid ${theme.colors.neutrals.grey7};
    margin: 0 ${theme.spacing(3)};
  `}

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    height: 11px;
    margin: 0 ${theme.spacing(2)};
  `}
`;
